'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; // @file: Link insert modal jsx file
// @auth: spc@data.me 2017/10/11

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

require('./styles.css');

var _link = require('../../../../icon/link.svg');

var _link2 = _interopRequireDefault(_link);

var _text = require('../../../../icon/text.svg');

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LinkModal = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(LinkModal, _Component);

    function LinkModal(props) {
        (0, _classCallCheck3.default)(this, LinkModal);

        var _this = (0, _possibleConstructorReturn3.default)(this, (LinkModal.__proto__ || (0, _getPrototypeOf2.default)(LinkModal)).call(this, props));

        _this.addLink = function () {
            var _this$state = _this.state,
                linkTitle = _this$state.linkTitle,
                linkTarget = _this$state.linkTarget;

            if (linkTitle === '') {
                _this.props.onSubmit(linkTarget, linkTarget);
            } else {
                _this.props.onSubmit(linkTitle, linkTarget);
            }
        };

        _this.updateLinkTitle = function (event) {
            _this.setState({
                linkTitle: event.target.value
            });
        };

        _this.updateLinkTarget = function (event) {
            _this.setState({
                linkTarget: event.target.value
            });
        };

        _this.state = {
            linkTitle: '',
            linkTarget: ''
        };
        return _this;
    }

    (0, _createClass3.default)(LinkModal, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.currentState) {
                this.setState({
                    linkTitle: (0, _utils.getSelectionText)(this.props.currentState)
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.linkTitle === '') {
                this.titleRef.focus();
            } else {
                this.linkRef.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'rde-modal' },
                _react2.default.createElement(
                    'div',
                    { className: 'rde-modal-body' },
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-title' },
                        '\u63D2\u5165\u94FE\u63A5'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-input-box' },
                        _react2.default.createElement('img', { src: _text2.default, alt: '' }),
                        _react2.default.createElement('input', {
                            className: 'rde-modal-input',
                            onChange: this.updateLinkTitle,
                            onBlur: this.updateLinkTitle,
                            value: this.state.linkTitle,
                            ref: function ref(_ref) {
                                _this2.titleRef = _ref;
                            },
                            placeholder: '\u8F93\u5165\u94FE\u63A5\u6587\u672C'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-input-box' },
                        _react2.default.createElement('img', { src: _link2.default, alt: '' }),
                        _react2.default.createElement('input', {
                            className: 'rde-modal-input',
                            onChange: this.updateLinkTarget,
                            onBlur: this.updateLinkTarget,
                            value: this.state.linkTarget,
                            ref: function ref(_ref2) {
                                _this2.linkRef = _ref2;
                            },
                            placeholder: '\u8F93\u5165\u94FE\u63A5\u5730\u5740'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'rde-modal-btns' },
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-ok', disabled: this.state.linkTarget === '', onClick: this.addLink },
                            '\u786E\u5B9A'
                        ),
                        _react2.default.createElement(
                            'button',
                            { className: 'rde-modal-btn-cancel', onClick: this.props.onCancel },
                            '\u53D6\u6D88'
                        )
                    )
                )
            );
        }
    }]);
    return LinkModal;
}(_react.Component), _class.propTypes = {
    currentState: _propTypes2.default.object.isRequired,
    onSubmit: _propTypes2.default.func,
    onCancel: _propTypes2.default.func
}, _temp);
exports.default = LinkModal;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/components/LinkModal/index.js
// module id = 112
// module chunks = 0